import { InputHTMLAttributes, forwardRef, LabelHTMLAttributes } from 'react';

import cx from 'classnames';

import s from './Checkbox.module.css';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  wrapperProps?: LabelHTMLAttributes<HTMLLabelElement>;
}

export default forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { wrapperProps, children, className, ...props },
  ref,
) {
  return (
    <label {...wrapperProps} className={cx(wrapperProps?.className, s.root)}>
      <input
        type="checkbox"
        ref={ref}
        className={cx(className, 'hidden')}
        {...props}
      />
      <div className={s.checkbox}>{children}</div>
    </label>
  );
});
